export const metroOneStyles = {
	header: {
		backgroundColor: '#a3c6eb',
	},
	sidebar: {
		backgroundColor: '#3b67ac',
		color: 'white',
	},
	title: {
		color: 'black',
	},
	button: {
		backgroundColor: '#0b2246',
		color: '#fff',
		fontWeight: 600,
		':hover': {
			backgroundColor: '#0b2246',
		},
	},
	text: {
		color: '#00305e',
		buttonLoadingColor: '#FFFFFF',
	},
	table: {
		headerBackgroundColor: '#0046AD',
		headerTextColor: '#ffffff',
	},
	platformName: {
		name: 'Metro One',
	},
	logo: {
		small: {
			src: '/metroOne/metro-one-icon.svg',
			height: 35,
			width: 35,
		},
		large: {
			src: '/metroOne/metro-one-logo.svg',
			height: 41,
			width: 75,
		},
	},
	favicon: {
		src: '/metroOne/metro-one-icon.svg',
	},
	socials: {},
	siteUrl: 'https://metro-one.net/',
	orgName: 'Metro One',
};
